import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class JotformService {
  constructor(private http: HttpClient) { }

  downloadInspectionPdf(vin: string) {
    return this.http.get(
      `${urls.API_URL}${urls.JOTFORM}/download/${encodeURIComponent(vin)}`,
      { responseType: 'blob' }
    ).pipe(catchError(errorHandl));
  }
}
